<div class="flag h-3 w-4 flag:{{code}}" aria-hidden="true"></div>
